import { create } from 'zustand';

export interface AllSiteSummaryFilterObject {
	current_stage_of_site_c: string;
	competition_site: boolean;
	adopted_site: boolean;
	lost_site?: boolean;
	ssm_site?: boolean;
	lastactivitydate: [Date | null, Date | null];
	visited_by: string;
	createddate: [Date | null, Date | null];
	mdicode?: string;
}

export interface SiteSummaryListingStore {
	allSiteSummaryFilter: AllSiteSummaryFilterObject;
	updateFilter: (filterObject: AllSiteSummaryFilterObject) => void;
	resetSiteSummaryFilter: () => void;
}

const initialState: { allSiteSummaryFilter: AllSiteSummaryFilterObject } = {
	allSiteSummaryFilter: {
		current_stage_of_site_c: '',
		competition_site: false,
		adopted_site: false,
		lost_site: false,
		ssm_site: false,
		lastactivitydate: [null, null],
		visited_by: '',
		createddate: [null, null],
		mdicode: '',
	},
};

export const useSiteSummaryListingStore = create<SiteSummaryListingStore>((set) => ({
	...initialState,
	updateFilter: (filterObject): void => {
		set((state) => ({
			...state,
			allSiteSummaryFilter: { ...state.allSiteSummaryFilter, ...filterObject },
		}));
	},
	resetSiteSummaryFilter: (): void => {
		set((state) => ({
			...state,
			allSiteSummaryFilter: {
				current_stage_of_site_c: '',
				competition_site: false,
				adopted_site: false,
				lost_site: false,
				ssm_site: false,
				lastactivitydate: [null, null],
				visited_by: '',
				createddate: [null, null],
				mdicode: '',
			},
		}));
	},
}));
